(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("aws-sdk/global"), require("amazon-cognito-identity-js"), require("react"), require("react-redux"));
	else if(typeof define === 'function' && define.amd)
		define(["aws-sdk/global", "amazon-cognito-identity-js", "react", "react-redux"], factory);
	else if(typeof exports === 'object')
		exports["ReactCognito"] = factory(require("aws-sdk/global"), require("amazon-cognito-identity-js"), require("react"), require("react-redux"));
	else
		root["ReactCognito"] = factory(root["aws-sdk/global"], root["AmazonCognitoIdentity"], root["React"], root["ReactRedux"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition